import { injectSwiperAfterEl } from './helpers/injectSwiperAfterEl.js'

// Рендерить каруселі готелів у визначених місцях сторінки.
// Якщо H2/H3 < MIN_QUANTITY — не рендерить свайпер, якщо <= 4 - тільки головний свайпер
// якщо 5+ - рендериться оба свайпера
export const renderCategorySliders = (
	titleElements,
	TITLE_CLASSES,
	sectionInfo,
	MIN_QUANTITY = 2
) => {
	const { targetTagIds, lastTagId } = getTagElementsInfo(
		titleElements,
		TITLE_CLASSES
	)

	const length = targetTagIds.length
	if (!length || length <= MIN_QUANTITY) return

	sectionInfo.forEach(({ sectionId, isMainSwiper }) => {
		if (isMainSwiper) {
			injectSwiperAfterEl(targetTagIds[0], sectionId)
		} else {
			length >= 5
				? injectSwiperAfterEl(lastTagId, sectionId)
				: document.getElementById(sectionId)?.remove()
		}
	})
}

// Отримує масив ID цільових тегів (H2 або H3) зі сторінки.
// Порівнює кількість H2 і H3 і повертає масив того типу, якого більше.
const getTagElementsInfo = (titleElements, TITLE_CLASSES) => {
	if (!titleElements && !titleElements.length) return []

	const H2Ids = []
	const H3Ids = []
	const lastTagId = { value: '' }

	titleElements.forEach((title, index) => {
		// Достаємо тег і перевіряємо, щоб він був один з тих який нам потрібен в TITLE_CLASSES
		const tag = title.tagName
		if (!TITLE_CLASSES[tag]) return

		const titleId = title.getAttribute('id')
		if (!titleId) return

		// Додаємо айді в потрібний масив
		tag === 'H2' ? H2Ids.push(titleId) : H3Ids.push(titleId)

		// Зберігаємо айди останнього елементу окремо
		if (index === titleElements.length - 1) lastTagId.value = titleId
	})

	const targetTagIds = H2Ids.length >= H3Ids.length ? H2Ids : H3Ids

	return { targetTagIds, lastTagId: lastTagId.value }
}
